



import Page from '../attendance/userLeave/personholiday.vue'
export default {
  name: 'userLeave',
  components: { Page },
}
